export default __webpack_public_path__ + "static/media/lavanya.bd907cd0.jpg";